import { Component, OnInit, ViewChild, Inject } from '@angular/core';
import { MatDialogRef, MatTableDataSource, MatSort, MAT_DIALOG_DATA, MatDialog } from '@angular/material';
import { RouterModule } from '@angular/router';

import { ApplicationConstants } from '../../providers/application-constants';
import { Utils } from '../../providers/utils';
import { QueryList } from '../../providers/query-list';
import { SubItemContentComponent } from '../sub-item-content/sub-item-content.component';

@Component({
  selector: 'app-sub-item-cat',
  templateUrl: './sub-item-cat.component.html',
  styleUrls: ['./sub-item-cat.component.css']
})
export class SubItemCatComponent implements OnInit {

  units = [];
  subItem_model = {'table_name':'sub_item', 'sub_item_id':'0', 'main_item_id':'', 'unit_id':'0', 
    'unit_name':'', 'no_barcode':1, 'sub_item_no':'', 'price':0, 'total_price':0, 'cost':0, 'total_cost':0, 
    'min_qty':0, 'min_sale_qty':1, 'price_flex':0, 'min_price':0, 'is_sale':0, 'is_purch':0, 
    'sub_item_cont':[]};

  private dp = [];
  displayedColumns = ['sub_item_no', 'main_item_name', 'quantity', 'cost', 'total_cost', 'price', 
    'total_price', 'edit', 'del'];
  dataSource = new MatTableDataSource(this.dp);
  @ViewChild(MatSort) sort: MatSort;

  subItemContDialogRef: MatDialogRef<SubItemContentComponent>;
  public cont_dialog_data = {};

  constructor(private utils: Utils,	private applicationConstants: ApplicationConstants,	
    private queryList: QueryList, public dialog: MatDialog, private dialogRef: MatDialogRef<SubItemCatComponent>, 
    @Inject(MAT_DIALOG_DATA) public dialog_data: any) { }

  ngOnInit() {
    
    let query = this.queryList.all_unit;
    let obj = {cmd: 'getList', query:query};
    this.utils.invokeHttp(this.applicationConstants.generalFile, obj)
      .subscribe(data => {
        this.applicationConstants.appComp.hideBusyCursor();
        this.units = data.data['list'];        
      });

    if(this.dialog_data['sub_item'] != undefined) {
      this.subItem_model = this.dialog_data['sub_item'];
      this.dp = this.subItem_model['sub_item_cont'];
      this.dataSource = new MatTableDataSource(this.dp);
      this.dataSource.sort = this.sort;
    }
  }

  changeNoBarcode() {
    if(this.subItem_model['no_barcode'] == 1)
      this.subItem_model['sub_item_no'] = ''; 
  }

  selectUnit() {
    if(this.dialog_data['main_item_type'] == "industrial" && this.dialog_data['all_sub_item'] != undefined) {
      let from_unit;
      this.units.forEach(element => {
        if(element.unit_id == this.subItem_model['unit_id']) {
          from_unit = element.from_unit;
        }
      });

      if(from_unit != '0') {
        this.dialog_data['all_sub_item'].forEach(element => {
          if(element.unit_id == from_unit && element.sub_item_cont.length > 0) {
            element.sub_item_cont.forEach(element1 => {
              this.dp.push(Object.assign({}, element1));
            });
            this.dataSource = new MatTableDataSource(this.dp);
            this.dataSource.sort = this.sort;
            this.subItem_model['sub_item_cont'] = this.dp;
          }
        });
      }

      if(this.subItem_model['sub_item_cont'].length > 0) {
        this.subItem_model['cost'] = 0;
        this.subItem_model['total_cost'] = 0;
        this.subItem_model['price'] = 0;
        this.subItem_model['total_price'] = 0;

        this.dp.forEach(element => {
          this.subItem_model['cost'] += element.total_cost;
          this.subItem_model['total_cost'] += element.total_cost;
          this.subItem_model['price'] += element.total_price;
          this.subItem_model['total_price'] += element.total_price;
        });
      }
    }
  }

  addContent() {
    this.subItemContDialogRef = this.dialog.open(SubItemContentComponent, {
      hasBackdrop: false,
      data: this.cont_dialog_data
    });
    this.subItemContDialogRef
      .afterClosed()
      .subscribe(result => {
        if(result != undefined) {
          result.index = this.dp.length;
          this.dp.push(result);
          this.dataSource = new MatTableDataSource(this.dp);
          this.dataSource.sort = this.sort;
          this.subItem_model['sub_item_cont'] = this.dp;

          this.subItem_model['cost'] = 0;
          this.subItem_model['total_cost'] = 0;
          this.subItem_model['price'] = 0;
          this.subItem_model['total_price'] = 0;

          this.dp.forEach(element => {
            this.subItem_model['cost'] += element.total_cost;
            this.subItem_model['total_cost'] += element.total_cost;
            this.subItem_model['price'] += element.total_price;
            this.subItem_model['total_price'] += element.total_price;
          });
        }
      });
  }

  editContent(row) {
    this.subItemContDialogRef = this.dialog.open(SubItemContentComponent, {
      hasBackdrop: false,
      data: row
    });
    this.subItemContDialogRef
      .afterClosed()
      .subscribe(result => {
        if(result != undefined) {
          this.subItem_model['cost'] = 0;
          this.subItem_model['total_cost'] = 0;
          this.subItem_model['price'] = 0;
          this.subItem_model['total_price'] = 0;

          this.dp.forEach(element => {
            if(element.index == result.index) {
              element = result;
            }
            this.subItem_model['cost'] += element.total_cost;
            this.subItem_model['total_cost'] += element.total_cost;
            this.subItem_model['price'] += element.total_price;
            this.subItem_model['total_price'] += element.total_price;
          });
          this.dataSource = new MatTableDataSource(this.dp);
          this.dataSource.sort = this.sort;
          this.subItem_model['sub_item_cont'] = this.dp;
        }
      });
  }

  deleteContent(row) {
    console.log(row);
    if (confirm("هل أنت متأكد من رغبتك بحذف هذا المكون؟")) {
      if (row.sub_item_content_id == '0') {
        this.dp.splice(row.index, 1);
        this.dataSource = new MatTableDataSource(this.dp);
        this.dataSource.sort = this.sort;

        let index = 0;
        this.subItem_model['cost'] = 0;
        this.subItem_model['total_cost'] = 0;
        this.subItem_model['price'] = 0;
        this.subItem_model['total_price'] = 0;

        this.dp.forEach(element => {
          element.index = index;
          this.subItem_model['cost'] += element.total_cost;
          this.subItem_model['total_cost'] += element.total_cost;
          this.subItem_model['price'] += element.total_price;
          this.subItem_model['total_price'] += element.total_price;
          index++;
        });
        this.subItem_model['sub_item_cont'] = this.dp;
      }
      else if (row.sub_item_content_id != '0') {
        let values = [{'table_name': row.table_name, 'sub_item_content_id':row.sub_item_content_id}];
        let obj = {cmd: 'deleteRec', values:values};

        this.utils.invokeHttp(this.applicationConstants.generalFile, obj)
          .subscribe(data => {
            this.applicationConstants.appComp.hideBusyCursor();
            if(data.status['type'] == 'success') {
              alert(" تمت العملية بنجاح ");
              this.dp.splice(row.index, 1);
              this.dataSource = new MatTableDataSource(this.dp);
              this.dataSource.sort = this.sort;

              let index = 0;
              this.subItem_model['cost'] = 0;
              this.subItem_model['total_cost'] = 0;
              this.subItem_model['price'] = 0;
              this.subItem_model['total_price'] = 0;

              this.dp.forEach(element => {
                element.index = index;
                this.subItem_model['cost'] += element.total_cost;
                this.subItem_model['total_cost'] += element.total_cost;
                this.subItem_model['price'] += element.total_price;
                this.subItem_model['total_price'] += element.total_price;
                index++;
              });
              this.subItem_model['sub_item_cont'] = this.dp;
            }
            else {
              alert(" حدث خطأ الرجاء المحاولة مرة أخرى ");
            }
          });
      }
    }
  }

  add() {
    if (this.subItem_model['unit_id'] != '0') {
      this.units.forEach(element => {
        if(element.unit_id == this.subItem_model['unit_id'])
          this.subItem_model['unit_name'] = element.unit_name;
      });
      this.dialogRef.close(this.subItem_model);
    }
    else if (this.subItem_model['unit_id'] == '0')
      alert (" الرجاء اختيار وحدة القياس ");
  }

  cancel() {
    this.dialogRef.close();  
  }

}
